export default "__VITE_ASSET__BP3BhjcG__"